import { render, staticRenderFns } from "./OrderExamine.vue?vue&type=template&id=24892775&scoped=true&"
import script from "./OrderExamine.vue?vue&type=script&lang=js&"
export * from "./OrderExamine.vue?vue&type=script&lang=js&"
import style0 from "./OrderExamine.vue?vue&type=style&index=0&id=24892775&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24892775",
  null
  
)

export default component.exports